import { createFileRoute } from "@tanstack/react-router";
import NavBar from "#/components/navbar/navbar";
import Footer from "#/components/footer/footer";
import Mdx from "#/components/MdxRemote";
import { metadataToHead } from "#/lib/seo";

export default function Page() {
  return (
    <>
      <header>
        <NavBar />
      </header>
      <main id="content" className="mx-auto mt-24 max-w-3xl space-y-10">
        <h1 className="text-center text-5xl">California Privacy Policy</h1>

        <section className="mx-8 space-y-5">
          <Mdx source={content} />
        </section>
      </main>
      <Footer />
    </>
  );
}

const content = `
**Effective Date: January 31, 2024**

## 1. Introduction
This privacy policy is designed to inform you about our practices regarding the collection, use, and sharing of personal information in compliance with the California Consumer Privacy Act (CCPA), as amended by the California Privacy Rights Act (CPRA).

## 2. Scope and Application
This policy applies to personal information we collect from users of our site who are residents of California. It covers information collected online through our website, mobile applications, and other online services.

## 3. Information Collection Practices
- **Categories of Personal Information Collected:**
  - Identifiers: Such as name, email address, phone number, and IP address.
  - Professional or Employment-Related Information: Including resume details, employment history, educational background, and job preferences.
  - Internet Activity: Browsing history and interactions with our website.
- **Methods of Collection:**
  - Directly from you when you register, apply for jobs, or update your profile.
  - Indirectly through your use of our site and services.

## 4. Use of Personal Information
- To match you with potential job opportunities.
- To communicate with you regarding job applications or site updates.
- For internal operations such as improving our services, analytics, and fraud prevention.
- We do not sell your personal information.

## 5. Consumer Rights Under the CCPA
- The right to know and request access to the personal information we collect.
- The right to request the deletion of personal information.
- The right to opt-out of the sale of personal information (not applicable as we do not sell personal information).
- The right to non-discrimination for exercising CCPA rights.
- The right to correct inaccurate information.
- The right to limit use and disclosure of sensitive personal information.

## 6. Requests for Information, Deletion, and Opt-Out
- Submit requests via [email/contact form/link].
- We will verify your identity before processing requests.
- Some requests may be subject to certain exceptions.

## 7. Response Timing and Format
- We aim to respond to verified requests within 45 days.

## 8. Sale of Personal Information
- Roamdoc does not sell personal information.

## 9. Children's Privacy
- Our site is not intended for individuals under the age of 16.
- We do not knowingly collect personal information from minors.

## 10. Data Security
- We implement reasonable security measures to protect your information.

## 11. Updates to the Privacy Policy
- This policy may be updated periodically. We will notify you of significant changes.

## 12. Contact Information
- For questions or concerns, please contact us at [roamdoc.com/contact-roamdoc](https://roamdoc.com/contact-roamdoc).

## 13. Accessibility
- This policy is available in alternative formats upon request to accommodate individuals with disabilities.

`;

export const metadata = {
  title: "California Privacy Policy  • Roamdoc",
  description: "California Privacy Policy for Roamdoc.",
  icons: [{ rel: "icon", url: "/favicon.ico" }],
  openGraph: {
    images: ["https://www.roamdoc.com/og-image.png"],
  },
  alternates: {
    canonical: `https://www.roamdoc.com/california-privacy-policy`,
  },
};

export const Route = createFileRoute("/(legal)/california-privacy-policy/")({
  component: Page,
  head: () => metadataToHead(metadata),
});
